import gql from 'graphql-tag';

export const fields = `
    name
    totalMotors
    aircraftStatuses {
        id
    }
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateAircraftModels (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateAircraftModels (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetAircraftModels (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetAircraftModels (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindAircraftModelById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindAircraftModelById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdWithRelationsQuery = gql`
    query DigitaiFindAircraftModelByIdWithRelations (
        $id: ID
        $constraint: QueryStatement
        $queryPaginateAircraftModelsAircraftStatuses: QueryStatement
        $constraintPaginateAircraftModelsAircraftStatuses: QueryStatement
        $queryPaginateAircraftStatuses: QueryStatement
        $constraintPaginateAircraftStatuses: QueryStatement
        $queryGetAircraftModelsAircraftStatuses: QueryStatement
        $constraintGetAircraftModelsAircraftStatuses: QueryStatement
    ) {
        object: digitaiFindAircraftModelById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        digitaiPaginateAircraftModelsAircraftStatuses (
            query: $queryPaginateAircraftModelsAircraftStatuses
            constraint: $constraintPaginateAircraftModelsAircraftStatuses
        ) {
            total
            rows
            count
        }
        digitaiPaginateAircraftStatuses (
            query: $queryPaginateAircraftStatuses
            constraint: $constraintPaginateAircraftStatuses
        ) {
            total
            rows
            count
        }
        digitaiGetAircraftModelsAircraftStatuses (
            query: $queryGetAircraftModelsAircraftStatuses
            constraint: $constraintGetAircraftModelsAircraftStatuses
        ) {
            aircraftStatusId
        }
        ${relationsFields}
    }
`;

export const findQuery = gql`
    query DigitaiFindAircraftModel (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindAircraftModel (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateAircraftModel (
        $payload: DigitaiCreateAircraftModelInput!
    ) {
        digitaiCreateAircraftModel (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateAircraftModels (
        $payload: [DigitaiCreateAircraftModelInput]!
    ) {
        digitaiCreateAircraftModels (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateAircraftModelById (
        $payload: DigitaiUpdateAircraftModelByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateAircraftModelById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateAircraftModels (
        $payload: DigitaiUpdateAircraftModelsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateAircraftModels (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteAircraftModelById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteAircraftModelById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteAircraftModels (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteAircraftModels (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
